module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-group-item"
  }, [_c('label', {
    class: {
      'orange-border': _vm.is_pending, 'not-allowed-pointer': _vm.is_unavailable
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.is_unavailable || _vm.disabled
    },
    domProps: {
      "checked": _vm.is_checked
    },
    on: {
      "change": function($event) {
        return _vm.changeValues($event.target.checked)
      }
    }
  }), _vm._v("\n\t\t" + _vm._s(_vm.role_desc) + "\n\t")]), _vm._v(" "), (_vm.credit_and_collection) ? _c('span', {
    staticClass: "label label-warning m-l-5"
  }, [_vm._v("\n\t\t(C&C Hold)\n\t")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd8e76d8!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/account-role-item.vue
// module id = M2cj
// module chunks = 0